import { Controller } from "@hotwired/stimulus"

// Connects to the data-controller="keyboard-shortcut"
export default class extends Controller {
  static targets = ["target"]

  connect() {
    this.handleShortcut = this.handleShortcut.bind(this)
    document.addEventListener("keydown", this.handleShortcut)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleShortcut)
  }

  handleShortcut(event) {
    if ((event.ctrlKey || event.metaKey) && event.key === "p") {
      event.preventDefault()
      this.element.click()
    }
  }
}
